import {
  all,
  fork,
  call,
  takeEvery,
  put,
} from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import Router from 'next/router'
import { startFetchPage } from './ducks/page'

import cartSaga from './sagas/cart'
import pageSaga from './sagas/page'
import presentsSaga from './sagas/presents'
import honeymoonSaga from './sagas/honeymoon'
import messagesSaga from './sagas/messages'

function routeObserver() {
  return eventChannel((emitter) => {
    Router.events.on('routeChangeStart', () => emitter('routeChange'))
    return () => {}
  })
}

function* routerSaga() {
  const router = yield call(routeObserver)

  yield takeEvery(router, function* event() {
    yield put(startFetchPage())
  })
}

export default function* rootSagas() {
  yield all([
    fork(cartSaga),
    fork(pageSaga),
    fork(presentsSaga),
    fork(honeymoonSaga),
    fork(messagesSaga),
    fork(routerSaga),
  ])
}
